import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MaskedInput from 'react-text-mask';
import style from './style.scss';

const Input = forwardRef(({
  enableAutocomplete = true,
  isRequired = false,
  className = '',
  notificationClass = 'notificationFromBottom',
  labelClassName = '',
  isMasked = false,
  isBadgeVisible = true,
  comment = '',
  errorMessage = '',
  errorClassName = '',
  label = null,
  placeHolder = '',
  value = '',
  hasError = false,
  isDisabled = false,
  notification = null,
  onFocusHandler = () => {},
  type = 'text',
  max = 0,
  onChange = () => {},
  ...restProps
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isRequiredState, setIsRequiredState] = useState(false);
  const [isNotificationShowing, setIsNotificationShowing] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    onFocusHandler();
  };

  const handleBlur = (e) => {
    if (e.target.value) {
      setIsRequiredState(false);
    } else {
      setIsRequiredState(isRequired);
    }
    !isRequired && setIsFocused(false);
  };

  const handleMouseEnter = () => {
    setIsNotificationShowing(true);
  };

  const handleMouseLeave = () => {
    setIsNotificationShowing(false);
  };

  const getAutoCompleteValue = () => {
    if (enableAutocomplete) {
      return 'on';
    }
    return 'new-password';
  };

  return (
    <label className={cn({ 'has-value': (isFocused || value && value.length || hasError), required: isRequiredState || hasError, [style.disabled]: isDisabled }, labelClassName)}>
      {
        label &&
          <span>
            {label}
            {
              isBadgeVisible &&
              <em>
                {isRequired && errorMessage === 'The input field is required' && 'Required'}
                {isRequired && errorMessage !== 'The input field is required' && hasError && 'Error'}
                {!isRequired && errorMessage !== 'The input field is required' && hasError && 'Error'}
                {isRequired && !hasError && 'Required'}
                {!isRequired && !hasError && 'Optional'}
              </em>
            }
          </span>
      }
      {
        isMasked ?
          <MaskedInput
            className={cn(className, style.input)}
            value={value || ''}
            mask={isMasked}
            disabled={isDisabled}
            placeholder={(isFocused || value && value.length || isDisabled || hasError) ? placeHolder : ''}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={onChange}
            type={type}
            max={max}
            {...restProps}
            ref={ref}
            autoComplete={getAutoCompleteValue()}
            data-form-type="other"
          />
        :
          <input
            className={cn(className, style.input)}
            value={value || ''}
            disabled={isDisabled}
            placeholder={(isFocused || value && value.length || isDisabled || hasError) ? placeHolder : ''}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={onChange}
            type={type}
            max={max}
            {...restProps}
            ref={ref}
            autoComplete={getAutoCompleteValue()}
            data-form-type="other"
          />
      }
      {
        notification &&
        <div className={cn(style.tooltip, isNotificationShowing && style.active)}>
          <i
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >i
          </i>
          <div className={cn(style[notificationClass])}>{notification}</div>
        </div>
      }
      {
        comment &&
          <div className={style.comment}>{comment}</div>
      }
      <div className={cn(style.error, errorClassName)}>{errorMessage !== 'The input field is required' && errorMessage}</div>
    </label>
  );
});

Input.propTypes = {
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  value: PropTypes.string,
  max: PropTypes.number,
  isDisabled: PropTypes.bool,
  label: PropTypes.node,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onFocusHandler: PropTypes.func,
  isBadgeVisible: PropTypes.bool,
  placeHolder: PropTypes.string,
  isMasked: PropTypes.any,
  comment: PropTypes.string,
  notification: PropTypes.string,
  errorClassName: PropTypes.string,
  notificationClass: PropTypes.string,
  enableAutocomplete: PropTypes.bool,
};

export default Input;
